jQuery(function($) {

	var state = {
        tags: '', 
        filter: '', 
        sort: 'populärt'
    }

	$(document).ready(function () {

		// Default values for tags		
		state.tags = getParamFromUrl('taggar');

		$('.tags input').each(function () {
			
			$this = $(this);
			tag = $this.val();
			tags = state.tags.split('+');
			
			if(tags.indexOf(tag) !== -1) {
				$this.attr('checked', 'checked');
			}
		});
	});

	// Manage tags options
    $('.tags input').on('click', function () {

		console.log('tag clicked');

		var $this = $(this);
        var tag = $this.val();
        var tags = state.tags.split('+');
        var idx = tags.indexOf(tag);

        if(idx == -1) {
            tags.push(tag);
			//$("input", this).attr("checked", "");
        }
        else {
            tags.splice(idx, 1);
			//$("input", this).removeAttr("checked");
        }

		for(var i = 0; i < tags.length; i++) {
			if(tags[i] == 0) {
				tags.splice(i,1);
			}
		}
		
        state.tags = tags.join('+');

        history.pushState(state, null, "?taggar=" + state.tags + "&filter="+state.filter+"&sortering="+state.sort);
    });

	// Filter content
 	window.addEventListener('popstate', function(e) {

		console.log('popstate');

        if (e.state != null){
        }
        else {
        }
    });
});

if (!Object.prototype.watch) {
	Object.defineProperty(Object.prototype, "watch", {
		  enumerable: false
		, configurable: true
		, writable: false
		, value: function (prop, handler) {
			var
			  oldval = this[prop]
			, newval = oldval
			, getter = function () {
				return newval;
			}
			, setter = function (val) {
				oldval = newval;
				return newval = handler.call(this, prop, oldval, val);
			}
			;
			
			if (delete this[prop]) { // can't watch constants
				Object.defineProperty(this, prop, {
					  get: getter
					, set: setter
					, enumerable: true
					, configurable: true
				});
			}
		}
	});
}

// object.unwatch
if (!Object.prototype.unwatch) {
	Object.defineProperty(Object.prototype, "unwatch", {
		  enumerable: false
		, configurable: true
		, writable: false
		, value: function (prop) {
			var val = this[prop];
			delete this[prop]; // remove accessors
			this[prop] = val;
		}
	});
}

function getParamFromUrl(name, url) {

    if (!url) url = window.location.href;
    	name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    
	if (!results) return '';
    if (!results[2]) return '';

	return decodeURIComponent(results[2]);
}